import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityVoid } from '../Type/PackEntityVoid'

interface DataModel {
	aid?: string
	cid?: string
	typeEnums?:
		| 'IM_MAIN_SWITCH'
		| 'LIVE'
		| 'VOD'
		| 'NET_CALL_G1'
		| 'NET_CALL_G2'
		| 'WHITE_BOARD'
		| 'CLOUD_CALL'
		| 'CHANNEL_SMS'
		| 'WEB_RECORD'
		| 'RCS_5G_MESSAGE'
		| 'TEL'
		| 'YI_DUN_V2'
		| 'CLOUD_CALL'
		| 'MUSIC_COPYRIGHT'
		| 'MEETING_SOLUTION'
		| 'MAAS_API'
		| 'EMOTIONAL_COMPANION_AGENT'
}

/**
 *	关闭功能时发送验证码
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 应用id
 * @param {string} [data.cid] 企业id
 * @param {'IM_MAIN_SWITCH'|'LIVE'|'VOD'|'NET_CALL_G1'|'NET_CALL_G2'|'WHITE_BOARD'|'CLOUD_CALL'|'CHANNEL_SMS'|'WEB_RECORD'|'RCS_5G_MESSAGE'|'TEL'|'YI_DUN_V2'|'CLOUD_CALL'|'MUSIC_COPYRIGHT'|'MEETING_SOLUTION'|'MAAS_API'|'EMOTIONAL_COMPANION_AGENT'} [data.typeEnums] 功能类型
 */

export function closeFunctionverificationCode(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityVoid>
export function closeFunctionverificationCode(
	data: DataModel,
	options?: IRequestOptions,
): Promise<PackEntityVoid extends { msg: unknown } ? PackEntityVoid['msg'] : undefined>
export function closeFunctionverificationCode(
	data: DataModel,
	options: IRequestOptionsWithPass | IRequestOptions = {},
) {
	const { aid, cid, typeEnums } = data
	return net('/frontApi/app/closeFunction/verificationCode', {
		method: 'post',
		params: {
			aid,
			cid,
			typeEnums,
		},

		...(options || {}),
	})
}
